import React, {useEffect} from 'react';
import {View, Platform} from 'react-native';
import {useSelector, useDispatch} from 'react-redux';

import {
  updateEmailVouchers,
  updatePhoneVouchers,
  updateUserIdVouchers,
} from 'src/Redux/reducers/ticket_vouchers.reducer';

import {handleDeepLinkNavigation} from 'src/Utils/deepLinkHelper';

import {createHuntInvite} from '../Utils/huntInviteFunctions';

import {updateDataAtPath} from 'src/Utils/fireUtils';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {useFirebaseData} from '../Utils/fireUtils';
import {cloudFlareOptimizeImage} from '../Utils/helpers';
import {mmkvStorage} from '../Utils/mmkvStorage';

const VoucherAndRequestsController = (props) => {
  console.log('VoucherAndRequestsController render');
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user?.userId);
  const contactEmail = useSelector((state) => state.user?.info?.contactEmail);
  var contactPhone = useSelector((state) => state.user?.info?.contactPhone);
  // fixing bug
  if (contactPhone?.current) {
    contactPhone = contactPhone?.current;
  }

  console.log({contactEmail, contactPhone, userId});

  const requests = useSelector((state) => state.user?.info?.requests);

  const playTestState = useSelector((state) => state.app_info?.playTestState);
  // const deviceUUID = useSelector((state) => state.app_info?.deviceUUID);

  const ticket_vouchers =
    useSelector((state) => state.ticket_vouchers) || props.ticket_vouchers;
  const checkForInviteNotificiation = () => {
    if (requests) {
      const requestFiltered = Object.values(requests).filter((request) => {
        return !request?.received && request.path;
      });
      console.log({requestFiltered});
      const resquest = requestFiltered?.[0];
      if (resquest) {
        updateDataAtPath(resquest?.path || 'error', {
          received: true,
        });
        console.log('checkForInviteNotificiation', {resquest});
        if (resquest?.type == 'ask_to_join_my_hunt') {
          if (resquest?.autoAccept) {
            return navigationRef.navigate('JoinHuntModal', {
              voucherCode: resquest?.joinCode,
              autoSubmit: true,
            });
          }
          navigationRef.navigate('ConfirmModal', {
            titleText: `${resquest?.createdByName} Invited You To Play On Their ${resquest?.huntName} Scavenger Hunt`,
            titleBodyText: `Confirm if you want to join this hunt. Only join the hunts of friends and family, and not people that you don't know! If you do not want to receive requests like this, in the future go you your profile and turn off discovarble.`,
            confirmText: `Join ${resquest?.createdByName} Hunt`,
            titleImage: resquest?.huntPhoto ? {uri: resquest?.huntPhoto} : null,
            cancelText: 'Cancel',
            handleConfirm: async (handleDone) => {
              console.log('agreed to join group');
              updateDataAtPath(resquest?.path || 'error', {
                accepted: true,
              });
              handleDone();
              navigationRef.navigate('JoinHuntModal', {
                voucherCode: resquest?.joinCode,
                autoSubmit: true,
              });
            },
          });
        } else if (resquest?.type == 'ask_for_invite_to_their_hunt') {
          navigationRef.navigate('ConfirmModal', {
            titleText: `${resquest?.askedByName} Asked To Join Your Scavenger Hunt`,
            titleBodyText: `Confirm if you ${resquest?.askedByName} to join your hunt. If you do not want to receive requests like this, in the future go to the game lobby and turn off discovarble.`,
            confirmText: `Let ${resquest?.createdByName} Join Your Hunt`,
            // explorers in front of world
            titleImage: {
              uri: cloudFlareOptimizeImage(
                'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648583369_original.png',
              ),
            },
            cancelText: 'Cancel',
            handleConfirm: async (handleDone) => {
              console.log('agreed to join group');
              updateDataAtPath(resquest?.path || 'error', {
                accepted: true,
              });
              handleDone();
              createHuntInvite(
                {
                  userId: resquest?.askedBy,
                },
                resquest,
                resquest?.groupId,
                true,
              );
            },
          });
        }
      }
    }
  };

  useEffect(() => {
    if (playTestState) {
      return;
    }
    checkForInviteNotificiation();
  }, [JSON.stringify(requests || {})]);

  const isLandingPage = useSelector(
    (state) => state.current_screen?.currentScreen == 'LandingPage',
  );

  const evaluateJs = (script) => {
    const code = ('' + script)
      .replace(/this\./gi, '')
      .replace(/global/gi, '__self__.getGlobals()')
      .replace(/updateDataAtPath/gi, '__self__.updateDataAtPath(');
    console.log({code});

    try {
      const execute = new Function('__self__', code);
      execute(this);
    } catch (codeError) {
      console.log({code, codeError});
    }
  };

  const checkForUnredeemedVouchers = async () => {
    const {allVouchers = [], voucherShows = 0} = ticket_vouchers;

    // check if in playtest
    if (playTestState) {
      return console.log('checkForUnredeemedVouchers: in PT state');
    }

    if (!userId) {
      return console.log('checkForUnredeemedVouchers: no user info');
    }

    // looking for vouchers
    // vouchers found on account
    const deepLinkURL = await mmkvStorage.getString('deepLinkURL');

    var unredeemedVouchers = allVouchers.filter((voucher) => {
      return !voucher.redeemed && !voucher.askedToRedeem;
    });
    if (!isLandingPage) {
      // if not on the landing page filter to only notifications
      unredeemedVouchers = unredeemedVouchers.filter((voucher) => {
        return voucher.type == 'notification';
      });
    }

    let seenVouchers = [];
    try {
      seenVouchers = (await mmkvStorage.getString('seenVouchers')) || '[]';
      seenVouchers = JSON.parse(seenVouchers);
      unredeemedVouchers = unredeemedVouchers.filter((voucher) => {
        return !seenVouchers.includes(voucher?.voucherCode);
      });
    } catch (error) {
      console.log({error});
      seenVouchers = [];
    }
    console.log({seenVouchers});

    console.log('checkForUnredeemedVouchers: looking for unredeemed vouchers', {
      unredeemedVouchers,
    });
    if (unredeemedVouchers?.[0]) {
      const firstVoucher = unredeemedVouchers?.[0] || {};
      const firstVoucherCode = firstVoucher?.voucherCode;

      const {
        type = 'ticket',
        subType = 'groupon',
        customCode = null,
        purchase = {},
      } = firstVoucher;
      const {tickets = 2} = purchase;

      if (Platform.OS == 'web') {
        return console.log('no notify on web');
      }

      if (firstVoucherCode) {
        console.log({voucherShows});
        if (voucherShows > 2) {
          return console.log('voucher modal blocked');
        }

        // navigating to help
        if (type == 'third_party') {
          if (userId && unredeemedVouchers?.[0]?.reviewUrl) {
            updateDataAtPath(
              `users/${userId || 'error'}/reviewURL/`,
              unredeemedVouchers?.[0]?.reviewUrl,
            );
          }
          navigationRef.navigate('GrouponRedemption', {
            voucherCode: firstVoucherCode,
            autoFound: true,
            subType: unredeemedVouchers?.[0]?.subType,
            ticketsQuantity: tickets,
            voucherSource: subType,
            autoSubmit: unredeemedVouchers?.[0]?.autoSubmit || false,
          });
        } else if (type == 'notification') {
          evaluateJs(customCode);
        } else {
          navigationRef.navigate('JoinHuntModal', {
            voucherCode: firstVoucherCode,
            autoFound: true,
          });
        }
        setTimeout(async () => {
          await updateDataAtPath(
            `transactions/purchases/${
              firstVoucherCode || 'error'
            }/askedToRedeem/`,
            1,
          );
          // saving code to async storage
          // prevents double view error
          try {
            seenVouchers.push(firstVoucherCode);
            await mmkvStorage.set('seenVouchers', JSON.stringify(seenVouchers));
          } catch (error) {
            console.log({error});
          }
        }, 300);

        // marking voucher as asked to redeem to stop infinite loop

        // deleting deep link voucher if already found
        mmkvStorage.delete('deepLinkURL');
      }
    } else if (deepLinkURL) {
      handleDeepLinkNavigation(deepLinkURL);
    }
    // console.log(
    //   'checkForUnredeemedVouchers: uy found',
    //   {
    //     allVouchers,
    //   },
    // );
  };

  useEffect(() => {
    if (playTestState) {
      return;
    }
    checkForUnredeemedVouchers();
  }, [JSON.stringify(ticket_vouchers || {})]);

  useEffect(() => {
    if (userId) {
      console.log('Check for unredeemed vouchers');
      checkForUnredeemedVouchers();
    }

    checkForInviteNotificiation();
  }, []);

  // getting all vouchers by email
  useFirebaseData(
    `transactions/purchases/`,
    (newEmailVouchers) => {
      dispatch(updateEmailVouchers(newEmailVouchers));
    },
    'email', // get matching
    contactEmail, // contact email
    false, // hide logs
    !contactEmail || playTestState, // suppress if pt or no contactEmail
  );

  // getting all vouchers by ownerUserId
  useFirebaseData(
    `transactions/purchases/`,
    (newUserIdVouchers) => {
      dispatch(updateUserIdVouchers(newUserIdVouchers));
    },
    'ownerUserId', // get matching
    userId, // user id
    false, // hide logs
    !userId || playTestState, // suppress if pt or no userId
  );

  // gettting all vouchers by phoneNumber
  useFirebaseData(
    `transactions/purchases/`,
    (newPhoneVouchers) => {
      dispatch(updatePhoneVouchers(newPhoneVouchers));
    },
    'phoneNumber', // get matching
    contactPhone, // phone number
    false, // hide logs
    !contactPhone || playTestState, //suppress if pt or no contact phone
  );

  // @ts-ignore
  const getGlobals = () => global;

  getGlobals();

  return <View />;
};

export default VoucherAndRequestsController;
